import React, { useState, useRef, forwardRef, useImperativeHandle } from "react";
import { Button } from "../../../../components/Button";
import { Input } from "../../../../components/Input";
import { ParceriaMacro } from "../../../../components/ParceriaMacro";
import Tabs from "../../../../components/Tabs/Tabs.tsx";
import { ImageUploadProduto } from "../../../../components/Upload/imageUploadProduto/ImageUploadProduto.tsx";
import LockedIcon from "../../../../components/LockedIcon/LockedIcon.tsx";
import "./styles.scss";

interface MidiasBoxProps {
  adicionaFoto: (newImages: {
    base64: string;
    imagem: string;
    size: number;
  }) => void;
  adicionaVideo: (newValue: string) => void;
  videosBloqueados?: boolean;
  maxImages?: number;
}

export const MidiasBox = forwardRef<{ triggerPhotoUpload: () => void }, MidiasBoxProps>(({
  adicionaFoto,
  adicionaVideo,
  videosBloqueados = false,
  maxImages,
}, ref) => {
  const [activeTab, setActiveTab] = useState("foto");
  const imageUploadRef = useRef<{ triggerFileInput: () => void }>(null);

  const [video, setVideo] = useState("");
  const [tabs, setTabs] = useState([
    { name: "Adicionar foto", value: "foto" },
    { name: "Adicionar vídeo", value: "video", lockedIcon: videosBloqueados ? <LockedIcon mensagem="Recurso disponível a partir do plano Essencial." width="3rem"/> : undefined},
  ]);

  const [foto, setFoto] = useState("");

  useImperativeHandle(ref, () => ({
    triggerPhotoUpload: () => {
      setActiveTab("foto");
      setTimeout(() => {
        imageUploadRef.current?.triggerFileInput();
      }, 100);
    }
  }));

  return (
    <div className="view-MidiasBox">
      <Tabs
        tabs={tabs}
        value={activeTab}
        onChange={(newValue) => {
          if(newValue === "video" && videosBloqueados) {
            return;
          }
          setActiveTab(newValue);
          if (newValue !== "avancado") {
            setTabs(tabs.filter((tab) => tab.value !== "avancado"));
          }
        }}
        tabsNumber={window.innerWidth <= 992 ? 2 : 3}
      />
      {activeTab === "foto" && (
        <div className="adicionar-foto">
          <ImageUploadProduto
            ref={imageUploadRef}
            key={1}
            value={foto}
            aspectRatio={1 / 1}
            minWidth={800}
            minHeight={800}
            resize={{ width: 900, height: 900 }}
            onChange={adicionaFoto}
            maxImages={maxImages}
          />
        </div>
      )}
      {activeTab === "video" && (
        <div className="adicionar-video">
          <Input
            label="Adicione um vídeo do Youtube"
            placeholder="Cole aqui o link do vídeo"
            type="text"
            name="sku"
            value={video}
            onChange={(newValue) => {
              setVideo(newValue);
            }}
          />
          <Button
            title="Adicionar Vídeo"
            className="botao_alterar"
            width="fit-content"
            icon={
              videosBloqueados ? (
                <LockedIcon
                mensagem="bloqueado"
                width="2rem"
                />
              ) : undefined
            }
            iconRight={true}
            fontSize="2.4rem"
            onClick={() => {
              if (!videosBloqueados) {
                adicionaVideo(video);
                setVideo("");
              }
            }}
          />
        </div>
      )}

      <ParceriaMacro />
    </div>
  );
});
